import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
})
export class SelectorComponent {
  @Input() title: string
  @Input() options: any[] = []
  @Input() isSelected: (option) => boolean
  @Input() selected: any
  @Input() autoClose = false

  @Output() onSelectOption = new EventEmitter<any>()
  @Output() onOpen = new EventEmitter<any>()

  @HostBinding('class.open') opened = false

  isOptionSelected(option) {
    if (this.isSelected) {
      return this.isSelected(option)
    } else if (this.selected) {
      return this.selected.value === option.value
    }
  }

  selectOption($event, option) {
    $event.stopPropagation()
    this.onSelectOption.emit(option)
    if (this.autoClose) {
      this.opened = false
      this.onOpen.emit(this.opened)
    }
  }

  toggleSelector($event) {
    $event.stopPropagation()
    this.opened = !this.opened
    this.onOpen.emit(this.opened)
  }
}
